import { isAxiosError } from "axios";
import { CollapseTransparent } from "../collapse"
import { CopyButton } from "../copy";
import WarningIcon from "@assets/icon/warning.svg?react"


export interface TableErrorProps{
  error: Error
}

export function TableError(props: TableErrorProps){
  if(isAxiosError(props.error)) return(
    <div className="relative overflow-auto bg-secondary-dark shadow-md  sm:rounded-lg">
    <div className="overflow-x-auto p-4 text-xl font-bold  px-3 text-white py-2 bg-danger-light/30">
      Terjadi Kesalahan
    </div>
    <div className="px-5 py-3 text-white">
      <WarningIcon className="w-10 block mx-auto text-danger" />
        <div className="text-center text-danger">
          <h2 className="text-2xl font-bold">Error</h2>
          <p className="text  mx-auto mb-10">
            {/* @ts-ignore */}
            {props.error?.response?.data?.message ?? props.error.message}
          </p>

        </div>
        <div className="text-start break-words max-w-full mb-5 text-gray-400">
          <div className="flex border-b border-gray-600 pb-1 py-2">
            <div className="basis-1/5 shrink-0" >
              Status Code
            </div>
            <div className="4/5">
              {props.error?.status}
            </div>
          </div>
          <div className="flex border-b border-gray-600 pb-1 py-2">
            <div className="basis-1/5 shrink-0" >
              Code
            </div>
            <div className="4/5">
              {props.error?.code}
            </div>
          </div>
          <div className="flex border-b border-gray-600 pb-1 py-2">
            <div className="basis-1/5 shrink-0" >
              Target URL
            </div>
            <div className="4/5 break-all grow-0">
              {props.error?.request?.responseURL}
            </div>
          </div>
        </div>
        <CollapseTransparent title="Server Meta Data " className="text-gray-400 max-w-full">
          <>
            <p className="whitespace-pre  overflow-x-auto mb-3 " >
              {JSON.stringify(props.error?.response?.data, null, 2)}
            </p>
            <CopyButton variant="danger" className="px-5" content={JSON.stringify(props.error?.response?.data, null, 2)} />
          </>
        </CollapseTransparent>
    </div>
  </div>
  )
  return (
    <div className="relative overflow-hidden bg-white shadow-md  sm:rounded-lg">
      <div className="overflow-x-auto p-4 text-xl font-bold  px-3 text-danger py-2 bg-danger-light/30">
        Terjadi Kesalahan
      </div>
      <p className="px-2 text-center max-w-xs mx-auto text-danger">
        {props?.error?.message}
      </p>
    </div>
  )
}